export enum SupportActions {
    DefaultSearch = "DefaultSearch",
    AutoBanSearch = "AutoBanSearch",
    AllSearch = "AllSearch",
    AutoReviewSearch = "AutoReviewSearch",
    GetUser = "GetUser",
    ShowFullUserData = "ShowFullUserData",
    ExportUser = "ExportUser",
    ExportUserChats = "ExportUserChats",
    FeedbackUser = "FeedbackUser",
    BanUser = "BanUser",
    UnbanUser = "UnbanUser",
    TemporaryUnbanUser = "TemporaryUnbanUser",
    UpdateUser = "UpdateUser",
    DeleteUser = "DeleteUser",
    UpdateToTestUser = "UpdateToTestUser",
    UpdateUserPhoto = "UpdateUserPhoto",
    DeleteUserPhoto = "DeleteUserPhoto",
    DeleteUserFeaturePhoto = "DeleteUserFeaturePhoto",
    SetGiftSubscription = "SetGiftSubscription",
    SetGiftBoost = "SetGiftBoost",
    SetGiftGreeting = "SetGiftGreeting",
    GetPendingVerifications = "GetPendingVerifications",
    FeedbackVerification = "FeedbackVerification",
    ForceVerification = "ForceVerification",
    PostponeReview = "PostponeReview",
    GetTemporaryUnbannedUsers = "GetTemporaryUnbannedUsers",
    GetQueueCountByGenders = "GetQueueCountByGenders",
    GetStatistics = "GetStatistics",
    GetGlobalStatistics = "GetGlobalStatistics",
    GetAbuseStatistics = "GetAbuseStatistics",
    GetActionStatistics = "GetActionStatistics",
    GetActionStatisticsProfiles = "GetActionStatisticsProfiles",
    GetReviewHistoryStatistics = "GetReviewHistoryStatistics",
    GetBlockedCountries = "GetBlockedCountries",
    AddBlockedCountry = "AddBlockedCountry",
    RemoveBlockedCountry = "RemoveBlockedCountry",
    GetMessages = "GetMessages",
    UpdateUserAbout = "UpdateUserAbout",
    SearchPushEventLogs = "SearchPushEventLogs",
    GetAdmins = "GetAdmins",
    CreateAdmin = "CreateAdmin",
    BlockAdmin = "BlockAdmin",
    UpdateAdmin = "UpdateAdmin",
    RegenerateAdminToken = "RegenerateAdminToken",
    GetReviewedUsersByAdmin = "GetReviewedUsersByAdmin",
    CreateBlackListUser = "CreateBlackListUser",
    GetBlackListUsers = "GetBlackListUsers",
    GetBlackListUser = "GetBlackListUser",
    AddBlackListUserPhotos = "AddBlackListUserPhotos",
    DeleteBlackListUser = "DeleteBlackListUser",
    SearchAbuseRules = "SearchAbuseRules",
    CreateAbuseRule = "CreateAbuseRule",
    UpdateAbuseRule = "UpdateAbuseRule",
    DeleteAbuseRule = "DeleteAbuseRule",
    TestAbuseRule = "TestAbuseRule",
    GetCustomActions = "GetCustomActions",
    ExecuteCustomAction = "ExecuteCustomAction",
    DevTest = "DevTest",
    GetAvailableImporters = "GetAvailableImporters",
    Import = "Import"
}
